// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RetweetOutlinedSvg from "@fishx/icons-svg/es/asn/RetweetOutlined";
import FishxIcon from '../components/FishxIcon';

var RetweetOutlined = function RetweetOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RetweetOutlinedSvg
  }));
};

RetweetOutlined.displayName = 'RetweetOutlined';
export default React.forwardRef(RetweetOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RetweetOutlined.js
// module id = 4007
// module chunks = 0